/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux';
import BaseDrawer from '../BaseDrawer/BaseDrawer';
import drawerActions from '@/Actions/drawer.actions';
import { Button } from '@/Components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/Components/ui/card';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { urls } from '@/Constants';
import moment from 'moment';
import { useEffect, useState, useRef } from 'react';
import storeServices from '@/Services/Form Services/store.services';
import bell from '@/Images/bell.png';
import { Eye, Plus, RefreshCcw } from 'lucide-react';
import { Tooltip } from '@mui/material';
import { useAuth } from '@/Components/Auth/Login/auth';
import { Chip } from '@mui/material';
import { LOService } from '@/Services';
import { modalActions } from '@/Actions';
import LeftOverModal from '@/Components/Modals/LeftOverModal/LeftOverModal';
import { LeftOverItemsModal } from '@/Components/Modals/LeftOverItemsModal';

function NotificationDrawer(props) {
    const { handleRefresh = () => { }, loading = false } = props;
    const drawerData = useSelector((state) => state?.drawer?.notificationDrawer);
    const { show, data = {} } = drawerData ?? {};
    const [stores, setStores] = useState([]);
    const [localLoading, setLocalLoading] = useState(false);
    const loadingTimeoutRef = useRef(null);
    const dispatch = useDispatch();
    const notification = useSelector((state) => state?.wastage?.notification);
    const { list = [] } = notification;
    const { orders = [], leftOver = [] } = list;
    const handleClose = () => {
        dispatch(drawerActions?.toggleNotificationDrawer(false));
    }
    const { userConfig = {}, appConfig = {} } = useAuth()
    const { level } = userConfig?.userDetails || {};

    const fetchStores = async () => {
        const req = {
            id: '',
            type: 'RETAIL',
        };
        try {
            const response = await storeServices.getStore(req);
            if (response?.statusCode === 200) {
                setStores(response?.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchStores();
    }, []);

    useEffect(() => {
        if (loading) {
            setLocalLoading(true);
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
        } else {
            loadingTimeoutRef.current = setTimeout(() => {
                setLocalLoading(false);
            }, 800);
        }

        return () => {
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
        };
    }, [loading]);

    const fetchPos = async (orderIds = []) => {
        const req = {
            data: {
                filters: {
                    purchaseOrderIds: orderIds,
                },
            },
        };
        try {
            const response = await inventoryAnalyticsServices?.fetchPoList({ req });
            if (response?.statusCode === 200) {
                const dataKey = `notificationOrderData_${Date.now()}`;
                sessionStorage.setItem(dataKey, JSON.stringify(response?.data));
                window.open(`${urls?.EXTENSION}${urls?.PRODUCTION_PLANS}?notification=true&orderDataKey=${dataKey}`, '_blank');
            }
        } catch (error) {
            console.log(error, 'error');
        }
    }
    const getTotalStoresLength = (storeId) => {
        return stores?.filter(store => store?.parentStore === storeId && store.type === 'RETAIL')?.length;
    }

    const renderBtns = () => {
        return (
            <Tooltip title='Fetch Notifications'>
                <span>
                    <RefreshCcw
                        size={20}
                        className={`cursor-pointer ${localLoading ? 'animate-spin' : ''} ${localLoading ? 'opacity-50 pointer-events-none' : ''}`}
                        onClick={handleRefresh}
                        disabled={localLoading}
                        style={localLoading ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                    />
                </span>
            </Tooltip>
        )
    }

    const handleLeftOver = (type, data) => {
        if (type === 'add') {
            // handleClose();
            dispatch(modalActions.toggleLeftOverCreateModal(true, {
                ...data,
                invDayEndOf: moment().format('YYYY-MM-DD'),
            }));
        } else {
            handleViewClick(data);
        }
    }
    const handleViewClick = async (data) => {
        try {
            const response = await LOService.listLOInventoryItems({
                id: data?.leftOverId,
            });
            if (response?.statusCode === 200) {
                let itemsData = {};
                const skuType = ['INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT'];
                if (Array.isArray(response?.data)) {
                    itemsData = response?.data?.reduce((acc, invItem) => {
                        if (acc?.[invItem?.skuType]) {
                            acc?.[invItem?.skuType]?.push(invItem);
                        } else {
                            acc[invItem?.skuType] = [invItem];
                        }
                        return acc;
                    }, {});
                } else {
                    itemsData = Object?.keys(response?.data)?.reduce((acc, invItem) => {
                        const currentTypeItems = response?.data?.[invItem];
                        acc[invItem] = currentTypeItems?.map((ele) => {
                            return {
                                ...ele,
                                qty: ele?.qty ?? ele?.count,
                                productName: ele?.name,
                                variantName: ele?.variant,
                            };
                        });
                        return acc;
                    }, {});
                }
                const skuTypeWithData = Object.keys(itemsData).filter((ele) => !skuType?.includes(ele));
                const values = skuTypeWithData.flatMap(key => [...itemsData[key]]);
                if (skuTypeWithData?.length > 0) {
                    if (itemsData['INGREDIENT']?.length > 0) {
                        itemsData['INGREDIENT'].push(...values);
                    } else {
                        itemsData['INGREDIENT'] = values;
                    }
                }
                itemsData = {
                    ...(itemsData['INTERMEDIATE'] && { INTERMEDIATE: itemsData['INTERMEDIATE'] }),
                    ...(itemsData['UNPACKED_PRODUCT'] && { UNPACKED_PRODUCT: itemsData['UNPACKED_PRODUCT'] }),
                    ...(itemsData['INGREDIENT'] && { INGREDIENT: itemsData['INGREDIENT'] })
                };
                dispatch(modalActions?.toggleLeftOverItemsModal(true, {
                    heading: `Day End Inventory of ${data?.processName} on ${moment().format('DD-MM-YYYY')}`,
                    items: itemsData,
                    date: moment().format('DD-MM-YYYY'),
                    processName: data?.processName,
                    isApprove: false,
                    advanceBill: false,
                    showTotal: false,
                    showPdf: false,
                    showPoDetails: false,
                    width: '60rem',
                    height: '40rem',
                    excludedColumns: [
                        'Packaged',
                        'Dispatched',
                        'Received',
                        'Returned Quantity',
                        'Fulfilled',
                        'From Process',
                        'PO Id',
                        'Returned',
                        // 'Category Name',
                        'Ordered Quantity',
                        'Item Price',
                        'Tax Percentage',
                        'Tax value',
                        'Total Item Amount',
                        'Discount %',
                        'Used For',
                    ],
                    hideItems: false,
                    isAdvanceBill: false,
                }));
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    return (
        <BaseDrawer
            header={data?.heading || 'Notifications'}
            open={show}
            onClose={handleClose}
            size='xs'
            renderBtns={renderBtns}
        >
            {orders?.length === 0 && leftOver?.length === 0 && (
                <div className='flex flex-col gap-3 justify-center items-center w-full p-2'>
                    <img src={bell} alt='bell' className='w-28 h-28' />
                    <p className='text-gray-700 text-[14px] items-center'>You're all caught up - no new notifications right now.</p>
                </div>
            )}
            <LeftOverModal handleRefresh={handleRefresh} />
            <LeftOverItemsModal />
            <div className='overflow-y-auto'>
                {orders?.length > 0 && (
                    <>
                        <h3 className='text-gray-800 text-[15px] font-semibold items-center'>Orders</h3>
                        {orders?.map((notification, idx) => (
                            <Card key={notification.id || idx} className='p-2 rounded-md bg-slate-100 mb-3 border border-slate-600'>
                                <CardHeader className='border-b'>
                                    <CardTitle className='flex flex-col items-start gap-2 font-medium text-gray-700 mb-2'>
                                        <div className='w-full flex items-center justify-between'>
                                            <span className='text-amber-800 py-0.5 rounded-md font-semibold'>
                                                {notification?.shiftName}
                                            </span>
                                            <span className='text-[13px] text-nowrap'>
                                                Expected Delivery Date:
                                                <span className='text-amber-800 px-2 py-0.5 rounded-md font-semibold'>
                                                    {moment(notification?.scheduledAt ?? notification?.orders?.[0]?.scheduledAt).format('DD-MM-YYYY')}
                                                </span>
                                            </span>
                                        </div>

                                        <div className='w-full text-sm'>
                                            <span>Orders:</span>
                                            <span className='text-amber-800 px-2 py-0.5 font-semibold'>
                                                {(notification?.orders ?? []).length}/{getTotalStoresLength(notification?.fromStoreId)}
                                            </span>
                                        </div>
                                    </CardTitle>
                                </CardHeader>
                                <CardContent>
                                    <div className='flex flex-wrap gap-2'>
                                        {notification?.orders?.map((order, idx) => (
                                            <Chip
                                                key={order.id || idx}
                                                label={order?.toStoreName || notification.message}
                                                size='small'
                                                title={order?.toStoreName || notification.message}
                                                className='bg-yellow-200 border border-yellow-800  transition-colors duration-200 shadow-sm font-semibold  rounded-md'
                                                style={{ fontSize: '12px', paddingLeft: 6, paddingRight: 6 }}
                                            />
                                        ))}
                                    </div>
                                </CardContent>
                                {level !== 1 && (
                                    <CardFooter className='bg-white rounded-md flex flex-col p-3 items-start gap-3'>
                                        <p className='text-sm text-gray-700'>
                                            Do you want to create a Production Plan now, or wait for remaining
                                            outlet orders?
                                        </p>
                                        <div className='flex justify-between w-full'>
                                            <Button variant='secondary' className='rounded-md bg-slate-200' onClick={handleClose}>
                                                No, Wait for Orders
                                            </Button>
                                            <Button className='bg-yellow-500 hover:bg-yellow-600 rounded-md' onClick={() => fetchPos(notification?.orders?.map(order => order?.id))}>
                                                Yes, Proceed
                                            </Button>
                                        </div>
                                    </CardFooter>
                                )}
                            </Card>
                        ))}
                    </>
                )}
                {/* left overs */}
                {leftOver?.length > 0 && (
                    <>
                        <h3 className='text-gray-800 text-[15px] font-semibold items-center'>Left Overs</h3>
                        {leftOver?.map((notification, idx) => (
                            <Card key={notification.id || idx} className='p-2 rounded-md bg-slate-100 mb-3 border border-slate-600'>
                                <CardHeader className='border-b'>
                                    <CardTitle className='flex flex-col items-start gap-2 font-medium text-gray-700 mb-2'>
                                        <div className='w-full flex items-center justify-between'>
                                            <span className='text-[14px] text-nowrap text-amber-800 py-0.5 rounded-md font-semibold'>
                                                {notification?.storeName}
                                            </span>
                                            <div className='flex items-center gap-1 text-sm'>
                                                <span>Left Overs:</span>
                                                <span className='text-amber-800 font-semibold'>
                                                    {notification?.leftOvers?.filter(leftOver => !leftOver?.isLeftOverDone)?.length}/{notification?.leftOvers?.length}
                                                </span>
                                            </div>
                                        </div>
                                    </CardTitle>
                                </CardHeader>
                                {notification?.leftOvers?.map((leftOver, idx) => {
                                    const leftOverData = {
                                        ...leftOver,
                                        StoreId: notification?.storeId,
                                    }
                                    return (
                                        <CardContent>
                                            <div className='w-full justify-between flex items-center gap-2'>
                                                <Chip
                                                    key={leftOver.id || idx}
                                                    label={leftOver?.processName}
                                                    size='small'
                                                    title={leftOver?.processName}
                                                    className='flex-1 bg-yellow-200 font-semibold border border-yellow-200 transition-all duration-200 shadow-sm font-medium rounded-md'
                                                    style={{
                                                        fontSize: '13px',
                                                        padding: '3px 6px',
                                                        maxWidth: '160px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                />
                                                {level !== 1 ? (
                                                    <Tooltip title={leftOver?.isLeftOverDone ? 'View Left Overs' : 'Add Left Overs'}>
                                                        {leftOver?.isLeftOverDone ? <Eye size={20} className='cursor-pointer' onClick={() => handleLeftOver('view', leftOverData)} /> : <Plus size={20} className='cursor-pointer' onClick={() => handleLeftOver('add', leftOverData)} />}
                                                    </Tooltip>
                                                ) : (
                                                    leftOver?.isLeftOverDone ? (
                                                        <Tooltip title='View Left Overs'>
                                                            <Eye size={20} className='cursor-pointer' onClick={() => handleLeftOver('view', leftOverData)} />
                                                        </Tooltip>
                                                    ) : (
                                                        ''
                                                    )
                                                )}
                                            </div>
                                        </CardContent>

                                    )
                                }
                                )}
                            </Card>
                        ))}
                    </>
                )
                }
            </div >
        </BaseDrawer >
    )
}
export default NotificationDrawer;
